import { IClaioMediaDrawableObject } from "../../../../../../domain/editableFormat/objects";
import { IClaioMediaDrawableObjectBean } from "../../../beans/objects";
import { AbstractObjectTranslator } from "../AbstractObjectTranslator";
import { ImageDrawableObjectTranslator } from "./ImageDrawableObjectTranslator";

export class ClaioMediaDrawableObjectTranslator<TObject extends IClaioMediaDrawableObject, TBean extends IClaioMediaDrawableObjectBean> extends AbstractObjectTranslator<TObject, TBean> {
  constructor() {
    super(new ImageDrawableObjectTranslator());
  }

  overwriteObject(source: TObject, bean: TBean, formatId: number): void {
  }

  overwriteBean(source: TBean, object: TObject): void {
    source["@src-path"] = undefined;
  }
}
